import React from "react";
import { Link } from "react-router-dom";
import { MdOutlineCode } from "react-icons/md";
import { MdOutlineCodeOff } from "react-icons/md";
import { FaFacebook, FaInstagram } from "react-icons/fa6";
import { FaLinkedin, FaDiscord } from "react-icons/fa";
import { AnimatePresence, motion } from "framer-motion";
import useTheme from "../../hooks/useTheme";

// components
import ThemeToggler from "./ThemeToggler";

const socialLinks = [
	{
		id: 1,
		title: "Facebook",
		icon: <FaFacebook />,
		url: "https://www.facebook.com/ivanvielled",
		color: "#1877F2",
	},
	{
		id: 2,
		title: "LinkedIn",
		icon: <FaLinkedin />,
		url: "https://www.linkedin.com/in/ivanvielle/",
		color: "#0077B5",
	},
	{
		id: 3,
		title: "Discord",
		icon: <FaDiscord />,
		url: "https://discord.com/users/alphachino5947",
		color: "#7289da",
	},
	{
		id: 4,
		title: "Instagram",
		icon: <FaInstagram />,
		url: "https://www.instagram.com/ivanvielle/",
		color: "#833AB4",
	},
];

const openBtnVariants = {
	tap: {
		scale: 0.5,
	},
};

const linkBtnVariants = {
	tap: {
		scale: 1,
	},
	hover: {
		scale: 1.3,
	},
	transition: {
		duration: 0.5,
	},
};

const socialMenuColVariants = {
	intial: {
		height: 0,
		opacity: 0,
	},
	animate: {
		height: "8em",
		opacity: 1,
	},
	exit: {
		height: 0,
		opacity: 0,
	},
	transition: {
		duration: 0.5,
		ease: "easeInOut",
	},
};

const SocialMenuMd = () => {
	const { theme, openSocials, setOpenSocials } = useTheme();

	const socialMenu = socialLinks.map((socialLink) => (
		<motion.button
			key={socialLink.id}
			variants={linkBtnVariants}
			whileHover="hover"
			whileTap="tap"
			transition="transition"
			style={{ color: `${socialLink.color}` }}>
			<Link
				to={socialLink.url}
				target="_blank">
				{socialLink.icon}
			</Link>
		</motion.button>
	));

	return (
		<div
			className={`fixed bottom-5 right-5 z-10 flex flex-col lg:hidden ${
				theme === "dark"
					? "shadow-stone-300 bg-black/20"
					: "shadow-stone-800 bg-white/20"
			} shadow-inner rounded-2xl p-1`}>
			<ThemeToggler />
			<motion.button
				variants={openBtnVariants}
				whileTap="tap"
				className={`p-2 mx-auto text-xl rounded-2xl hover:text-green-800`}
				onClick={() => setOpenSocials((prev) => !prev)}>
				{openSocials ? <MdOutlineCodeOff /> : <MdOutlineCode />}
			</motion.button>
			<AnimatePresence>
				{openSocials && (
					<motion.div
						variants={socialMenuColVariants}
						initial="initial"
						animate="animate"
						exit="exit"
						transition="transition"
						className="flex flex-col items-center justify-evenly overflow-hidden text-xl">
						{socialMenu}
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};

export default SocialMenuMd;
